"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var __jsx = _react["default"].createElement;

/**
 * Input Raw
 */
var resetStyles = {
  opacity: 0,
  width: 0,
  position: "absolute",
  overflow: "hidden",
  margin: 0,
  padding: 0
};

function RadioRaw_(props) {
  var sx = props.sx,
      inputRef = props.inputRef,
      type = props.type,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "inputRef", "type"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return (0, _.jsx)("input", (0, _extends2["default"])({
    sx: [resetStyles, css]
  }, restProps, {
    type: "radio",
    ref: inputRef
  }));
}

var _default = RadioRaw_;
exports["default"] = _default;